import { render } from "./addSalary.vue?vue&type=template&id=564a42e4"
import script from "./addSalary.vue?vue&type=script&lang=js"
export * from "./addSalary.vue?vue&type=script&lang=js"

import "./addSalary.vue?vue&type=style&index=0&id=564a42e4&lang=css"

import exportComponent from "/home/lcs/jenkins/workspace/v2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__